var map = {
	"./link_1.png": "./src/assets/img/home/link_1.png",
	"./link_2.png": "./src/assets/img/home/link_2.png",
	"./link_3.png": "./src/assets/img/home/link_3.png",
	"./link_4.png": "./src/assets/img/home/link_4.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/home sync recursive ^\\.\\/link_.*\\.png$";